/**
 * Formats a price in cents using the shop money format.
 * Strips trailing decimal zeros for whole-number amounts (e.g. kr. 120,00 → kr. 120).
 */
export default function formatMoney(cents, format = window.theme?.moneyFormat) {
  const amount = typeof cents === 'string' ? Number(cents.replace('.', '')) : Number(cents);
  const formatted = Shopify.formatMoney(amount, format);

  if (amount % 100 !== 0) {
    return formatted;
  }

  return formatted
    .replace(/[.,]00(\s)/, '$1')
    .replace(/[.,]00$/, '');
}
